import { FaBookmark } from "react-icons/fa";
import React from "react";
import {
  Grid,
  View,
  useTheme,
  Heading
} from '@aws-amplify/ui-react';
import AppHelmet from "../components/ui/AppHelmet";
import styled from 'styled-components';

export function TermsAndCondition() {

  const { tokens } = useTheme();
  const ViewCustom = styled(View)`

    h2 {
        font-weight: 400;
        font-size: 2.5vh;
        color: black;
        margin-top: 30px;
    }

    span {
        font-weight: 400;
        font-size: 2.5vh;
        color: black;
    }
  `;
  
  return (
    <div>
      <AppHelmet title="Merum" />
      <Grid
            templateColumns={{ base: '1fr', medium: '2fr 4fr 2fr', large: '3fr 6fr 3fr' }}
            templateRows={{ base: 'repeat(5, 6rem)', medium: 'repeat(6, 6rem)', large: 'repeat(5, 6rem)' }}
            gap={tokens.space.small}
            backgroundColor="#F5F5F5"
            marginBottom={{base: "5em", small: "4em",  medium: "4em", large: "3em" }}
        >
            <View
                rowSpan={{ base: 1, medium: 6, large: 6 }}
                backgroundColor="#F5F5F5"
                textAlign="left"
            >
            </View>
            <ViewCustom
                rowSpan={{ base: 8, medium: 6, large: 6 }}
                backgroundColor="#F5F5F5"
                textAlign="left"
                marginLeft={{ base: "1em", medium: "1em", large: "1em" }}
                marginTop={{ base: "2em", medium: "3em", large: "3em" }}
            >
                    <Heading 
                        level={4}
                        fontWeight={"bold"}
                        marginBottom={"1em"}
                    >
                        Privacy Policy and Terms of Service
                    </Heading>
                    <h2><FaBookmark fontSize={'13px'}/>&nbsp;<span style={{fontWeight: "bold"}}>Introduction</span></h2>
                    <p><span >Welcome to our platform. This document outlines the terms of service and privacy policy for our SaaS platform and marketplace. By signing up and using our platform, you agree to these terms and conditions.</span></p>
                    <h2><FaBookmark fontSize={'13px'}/>&nbsp;<span style={{fontWeight: "bold"}}>Data Collection</span></h2>
                    <p><span >When you sign up, we collect the following information:</span></p>
                    <ul>
                    <li><span >Name</span></li>
                    <li><span >Email</span></li>
                    <li><span >Phone number</span></li>
                    <li><span >Company name</span></li>
                    <li><span >Company type</span></li>
                    <li><span >Other relevant company details</span></li>
                    </ul>
                    <h2><FaBookmark fontSize={'13px'}/>&nbsp;<span style={{fontWeight: "bold"}}>Data Usage</span></h2>
                    <p><span >We use the collected data for the following purposes:</span></p>
                    <ul>
                    <li><span >To profile users and reach out for additional questions or clarifications.</span></li>
                    <li><span >To initiate the compliance process for selling in the US and exporting from Italy.</span></li>
                    <li><span >For potential future uses, including marketing, analytics, and third-party sharing.</span></li>
                    </ul>
                    <h2><FaBookmark fontSize={'13px'}/>&nbsp;<span style={{fontWeight: "bold"}}>User Rights</span></h2>
                    <p><span >You have the right to:</span></p>
                    <ul>
                    <li><span >Access the personal data we hold about you.</span></li>
                    <li><span >Modify or update your data.</span></li>
                    <li><span >Delete your data.</span></li>
                    </ul>
                    <p><span >If you wish to exercise any of these rights, please contact us using the contact details provided below.</span></p>
                    <h2><FaBookmark fontSize={'13px'}/>&nbsp;<span style={{fontWeight: "bold"}}>Security</span></h2>
                    <p><span >We take the security of your data seriously and implement industry-standard measures to protect it. However, no method of transmission over the internet or electronic storage is 100% secure. While we strive to protect your personal data, we cannot guarantee its absolute security.</span></p>
                    <h2><FaBookmark fontSize={'13px'}/>&nbsp;<span style={{fontWeight: "bold"}}>Third-Party Integrations</span></h2>
                    <p><span >We may share your data with third parties for the purposes of compliance and to facilitate sales. We will always seek your consent before sharing your data for any other purposes.</span></p>
                    <h2><FaBookmark fontSize={'13px'}/>&nbsp;<span style={{fontWeight: "bold"}}>Changes to This Policy</span></h2>
                    <p><span >We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page. It is advised to review this privacy policy periodically for any changes.</span></p>
                    <h2><FaBookmark fontSize={'13px'}/>&nbsp;<span style={{fontWeight: "bold"}}>Contact Us</span></h2>
                    <p><span >If you have any questions or concerns about this privacy policy, please contact us at legal@merum.club.</span></p>
                                
            </ViewCustom>
            <View
                rowSpan={{ base: 1, medium: 6, large: 6 }}
                backgroundColor="#F5F5F5"
                textAlign="left"
            >
            </View>
        </Grid>
       
    </div>
  );
};

export default TermsAndCondition;
